/* eslint-disable no-bitwise */
import { USER_COLORS } from "shared/constants/team-colors"

export function getUserColor(
  userID: string | number | null | undefined
): string {
  const str = String(userID)
  let hash = 0

  // Simple DJB2 hash function
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0 // Convert to 32-bit integer
  }

  const index = Math.abs(hash) % USER_COLORS.length
  return USER_COLORS[index]
}
